import { render, staticRenderFns } from "./data.vue?vue&type=template&id=5911f18a&scoped=true&"
import script from "./data.vue?vue&type=script&lang=js&"
export * from "./data.vue?vue&type=script&lang=js&"
import style0 from "./data.vue?vue&type=style&index=0&id=5911f18a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../ytht-h5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5911f18a",
  null
  
)

export default component.exports